import { render, staticRenderFns } from "./goAlipay.vue?vue&type=template&id=38facf53&scoped=true"
import script from "./goAlipay.vue?vue&type=script&lang=js"
export * from "./goAlipay.vue?vue&type=script&lang=js"
import style0 from "./goAlipay.vue?vue&type=style&index=0&id=38facf53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38facf53",
  null
  
)

export default component.exports